// extracted by mini-css-extract-plugin
export default {"avatar-group":"yp1Ln","avatar":"hXnln","count":"JJiUG"};